import React from 'react';
import PropTypes from 'prop-types';

import { I18n } from 'Locales';
import { Fab } from 'Components';
import { mockFunction } from 'Helpers';
import { ColumnView } from 'Containers';
import { ICON_COLOR } from 'Constants';
import { ClockExpired, Logout } from 'Icons';

import './style.scss';

const DonorResultNotSaved = ({ clearSession = mockFunction }) => (
  <div id="donor-result-not-saved">
    <ColumnView paddingHorizontal={20}>
      <ClockExpired fillColor={ICON_COLOR.RED} size={88} />
      <div className="screen-title pt-24">{I18n.t('flow:donorResultNotSaved.title')}</div>
      <div className="screen-subtitle pt-24">{I18n.t('flow:donorResultNotSaved.body')}</div>
    </ColumnView>

    <Fab disabled={false} onClick={clearSession} position={'right-bottom'} slot={'fixed'}>
      <Logout fillColor={ICON_COLOR.WHITE} />
    </Fab>
  </div>
);

DonorResultNotSaved.propTypes = {
  clearSession: PropTypes.func
};

export default DonorResultNotSaved;
